//@flow
// import { calculateAQI } from "aqi-calc"
import styled from "styled-components"

export type Level = "Very High" | "High" | "Medium" | "Low" | "No Data"
export type Metric = "pm2_5" | "pm10" | "o3"
export type Breakpoint = { high: number, low: number }

export const Breakpoints: { [Level]: Breakpoint } = {
  "Very High": { high: 999, low: 500 },
  High: { high: 499, low: 70 },
  Medium: { high: 69, low: 30 },
  Low: { high: 29, low: 0 }
}

export const levelForValue = (value: number): Level => {
  if (value <= 0) {
    return "No Data"
  }
  if (value < 30) {
    return "Low"
  }
  if (value < 70) {
    return "Medium"
  }
  if (value < 500) {
    return "High"
  }
  return "Very High"
}

export const foregroundForLevel = (level: Level): string => {
  switch (level) {
    case "Very High":
    case "High":
    case "No Data":
      return "#ffffff"
    default:
      return "#000000"
  }
}

export const backgroundForLevel = (level: Level): string => {
  switch (level) {
    case "Very High":
      return "#921212"
    case "High":
      return "#ee3030"
    case "Medium":
      return "#fdbd10"
    default:
      return "#6fbd44"
  }
}

export const colorsForLevel = (
  aqi: ?number
): {
  foreground: string,
  background: string
} => {
  if (!aqi || aqi <= 0) {
    return { foreground: "#fff", background: "#919191" }
  }
  let level: Level
  switch (true) {
    case aqi < 30:
      level = "Low"
      break
    case aqi < 70:
      level = "Medium"
      break
    case aqi < 500:
      level = "High"
      break
    default:
      level = "Very High"
  }
  return {
    foreground: foregroundForLevel(level),
    background: backgroundForLevel(level)
  }
}

export const levels: Array<Level> = ["Very High", "High", "Medium", "Low"]

export const Legend = styled.ol`
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  width: ${({ compact }) => (compact ? 98 : 140)}px;
  flex-basis: ${({ compact }) => (compact ? 88 : 140)}px;
  margin-right: 2rem;
  flex-shrink: 0;
  flex-grow: 0;
  min-height: ${props => props.minHeight || "auto"};
`

export const AqiLevel = styled.li`
  list-style: none;
  text-align: center;
  align-items: center;
  display: flex;
  flex-direction: column;
  font-family: "din-condensed";
  font-size: ${({ compact }) => (compact ? 20 : 30)}px;
  padding: 0 ${({ compact }) => (compact ? 0.5 : 0)}rem;
  background: ${({ level }) => backgroundForLevel(level)};
  color: ${({ level }) => foregroundForLevel(level)};
  flex-grow: 1;
  flex-shrink: 0;
  flex-basis: 25%;
  text-transform: uppercase;
  margin: 0;

  &:first-child {
    border-top-left-radius: 1rem;
    border-top-right-radius: 1rem;
  }

  &:last-child {
    border-bottom-left-radius: 1rem;
    border-bottom-right-radius: 1rem;
  }
`

export const AqiDescription = styled.p`
  display: block;
  padding: 0 ${({ compact }) => (compact ? 0.5 : 2)}rem;
  margin: auto;
`

export const AqiTitle = AqiDescription.extend`
  font-size: 22px;
  text-align: center;
  padding: 0;
  margin-bottom: 0;
`

export const AqiSubtitle = AqiDescription.extend`
  font-size: 16px;
  font-weight: 300;
  text-align: center;
  padding: 0;
  margin-top: 0;
`

export const AqiLegendLabel = styled.span`text-transform: lowercase;`



// WEBPACK FOOTER //
// ./src/Kiosk/Shared/AQILegend.js